<template lang="pug">
  .modification
    template(v-if="!loading")
      template(
        v-if='isRecordEventsData || (isRecordModificationData && !challengeMode)'
        )
        template(v-if='isRecordEventsData')
          collapsed-data-sections(:sections="[leiEvents]")
        template(v-if='isRecordModificationData && isDownloadedAllModifications && !challengeMode')
          collapsed-data-sections(:sections="modificationDetails")
        .modification-disclaimer
          p The Golden Copy files, which are the data source for LEI Search, contain maximum one parent relationship
            | &nbsp;information per direct or ultimate parent relationship. A replacement of a relationship record with
            | a reporting exception, or vice versa, is listed in the change history by with the addition of the
            | replacing record and not also with the removal of the replaced record.

          p History of field changes reaches back to the introduction of the Golden Copy files (9th February 2018).
      template(v-else)
        lei-info-label.modification__no-data(type="placeholder" :text="noDataNotification")
      events-fixed-challenge(
        v-if="challengeMode"
        :sticky="isRecordEventsData"
        )
    template(v-else)
      loading
</template>

<script>
import record from '../../../constants/tooltips/record'

import { mapGetters, mapState, } from 'vuex'
import isEmpty from 'lodash/isEmpty'

import Challenge from '@/mixins/challenge'

import CollapsedDataSections from '@/components/record-details/CollapsedDataSections'
import Loading from '@/components/lei-components/Loading'
import EventsFixedChallenge from '@/components/challenge-components/EventsFixedChallenge'
import LeiInfoLabel from '@/components/lei-components/LeiInfoLabel'




export default {
  name: 'RecordModificationsInfo',
  components: {
    CollapsedDataSections,
    Loading,
    EventsFixedChallenge,
    LeiInfoLabel,
  },
  mixins: [ Challenge, ],
  data () {
    return {
      modificationDetails: [],
    }
  },
  computed: {
    noDataNotification () {
      if (this.challengeMode) return 'No entity events available'
      return 'No entity events or history available'
    },
    leiEvents () {
      return {
        title: 'Legal Entity Events',
        data: this.companyEvents,
        property: 'showEventsChangeLog',
        tableLayout: 'events',
        tip: record.eventsLog,
      }
    },
    leiModifications () {
      return {
        title: 'LEI Record changes',
        data: this.getLeiModifications,
        property: 'showChangeLog',
        tableLayout: 'changes',
        // tip: record.sectionChangelog,
      }
    },
    rrModifications () {
      return {
        title: 'Relationship Record changes',
        data: this.getRRModifications,
        property: 'showRRChanges',
        extraField: true,
        tableLayout: 'changes',
        // tip: record.sectionChangelog,
      }
    },
    repexModifications () {
      return {
        title: 'Reporting Exceptions changes',
        data: this.getRepexModifications,
        property: 'showREPEXChanges',
        extraField: true,
        tableLayout: 'changes',
        // tip: record.sectionChangelog,
      }
    },
    getLeiModifications () {
      return this.recordModifications.lei
    },
    getRRModifications () {
      return this.recordModifications.rr
    },
    getRepexModifications () {
      return this.recordModifications.repex
    },
    isLeiModifications () {
      return Boolean(this.getLeiModifications.data && !isEmpty(this.getLeiModifications.data))
    },
    isRRModifications () {
      return Boolean(this.getRRModifications.data && !isEmpty(this.getRRModifications.data))
    },
    isRepexModifications () {
      return Boolean(this.getRepexModifications.data && !isEmpty(this.getRepexModifications.data))
    },
    isRecordModificationData () {
      return this.isLeiModifications || this.isRRModifications || this.isRepexModifications
    },
    isRecordEventsData () {
      return this.companyEvents ? this.companyEvents.length > 0 : false
    },
    isDownloadedAllModifications () {
      return Boolean(this.getLeiModifications.type && this.getRRModifications.type && this.getRepexModifications.type)
    },

    ...mapState('record', [ 'recordModifications', 'loading', ]),
    ...mapGetters('record', [ 'companyEvents', ]),
  },
  watch: {
    recordModifications: {
      handler () {
        this.addModificationsData()
      },
      deep: true,
    },
  },
  mounted () {
    this.addModificationsData()
  },
  methods: {
    addModificationsData () {
      if (this.isDownloadedAllModifications) {
        this.modificationDetails = []
        if (this.isLeiModifications) this.modificationDetails.push(this.leiModifications)
        if (this.isRRModifications) this.modificationDetails.push(this.rrModifications)
        if (this.isRepexModifications) this.modificationDetails.push(this.repexModifications)
      }
    },
  },
}
</script>

<style scoped lang="stylus">
@import "../../../assets/styles/variables.styl"

.modification
  position relative
  &__no-data
    margin 0 0 50px !important
    @media screen and (max-width: $laptop)
      margin 0 0 25px !important

.modification-disclaimer
  padding: 20px 0 0
  border-top: 1px solid $disabled-border

  p
    padding-bottom: 20px
    color: $default-color
    font-weight: 500
    line-height: 1.4

</style>



// WEBPACK FOOTER //
// src/components/record-details/modifications/RecordModificationsInfo.vue